import React from 'react';
import { Badge, Gutter } from '@axiom/ui';

export type NewCandidatesBadgeProps = {
  name: string;
  show?: boolean;
};

export const NewCandidatesBadge = ({
  name,
  show = false,
}: NewCandidatesBadgeProps) => {
  return show ? (
    <Gutter top="16px">
      <Badge background="green" name={name}>
        NEW
      </Badge>
    </Gutter>
  ) : null;
};
